// extracted by extract-css-chunks-webpack-plugin
module.exports = {"btnCheckBoxBlock":"_1Eabz","btnSizeOveride":"A7yRG"};